import { render, staticRenderFns } from "./TagApplied.vue?vue&type=template&id=72948519&scoped=true"
import script from "./TagApplied.vue?vue&type=script&lang=js"
export * from "./TagApplied.vue?vue&type=script&lang=js"
import style0 from "./TagApplied.vue?vue&type=style&index=0&id=72948519&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72948519",
  null
  
)

export default component.exports